import { Article } from '../types';

class ArticleDetailsRepository extends ArticleRepository<Article> {
  async get(id: string) {
    return this._get({ url: `/articles/${id}`, cache: 'always' });
  }
}

export const articleDetailsRepository = new ArticleDetailsRepository();
